import { render, staticRenderFns } from "./GalleryItem.vue?vue&type=template&id=a47df196&scoped=true&"
import script from "./GalleryItem.vue?vue&type=script&lang=js&"
export * from "./GalleryItem.vue?vue&type=script&lang=js&"
import style0 from "./GalleryItem.vue?vue&type=style&index=0&id=a47df196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47df196",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VDivider,VImg})
